import ImageBlock from './ImageBlock';

function testBlock(block, contentState) {
  if (block.getType() === 'atomic') {
    const key = block.getEntityAt(0);
    return key && contentState.getEntity(key).getType() === 'IMAGE';
  }
  return false;
}

export default function blockRenderer(block, contentState, blockProps) {
  return (
    testBlock(block, contentState) && {
      component: ImageBlock,
      editable: false,
      props: blockProps,
    }
  );
}
